import { useCallback, useRef } from 'react'

export const useLastItemRef = onFetch => {
  const observedElement = useRef()

  const lastFeedItem = useCallback(
    node => {
      if (observedElement.current) observedElement.current.disconnect()
      observedElement.current = new IntersectionObserver(
        e => {
          if (e[0].isIntersecting) {
            if (onFetch) onFetch()
          }
        },
        {
          threshold: 0.01
        }
      )
      if (node) observedElement.current.observe(node)
    },
    [onFetch]
  )

  return lastFeedItem
}
